var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconActivity = function SvgIconActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.031 2.75a1 1 0 0 1 .903.644l5.19 13.622 2.732-5.463A1 1 0 0 1 18.75 11h3a1 1 0 1 1 0 2h-2.382l-3.474 6.947a1 1 0 0 1-1.828-.091L8.919 6.346 6.16 12.414a1 1 0 0 1-.91.586h-3a1 1 0 1 1 0-2h2.356L8.09 3.336a1 1 0 0 1 .941-.586"
  })));
};
export default SvgIconActivity;